module.exports = __webpack_public_path__ + "img/gas_rewards_icon.38db020f.svg";